module.exports = __webpack_public_path__ + "img/21_rain_1.85089c68.jpg";